export const originalSources = Object.freeze({
    ORG: "ORG",
    SELF: "SELF",
    REF: "REF",
    SMS: "SMS",
    MODAL: "MODAL",
  });